// extracted by mini-css-extract-plugin
export default {"AppSkeleton":"AppSkeleton_AppSkeleton__ppSV7","SideDrawer":"AppSkeleton_SideDrawer__mZYq5","child":"AppSkeleton_child__nnSiI"};